import * as THREE from "three"

import { TextGeometry } from "three/examples/jsm/Addons.js"
import Experience from "../../../Experience"


import Home from "./Home"


export default class PageTemplate {

    constructor(pageTitle, primaryColor, secondaryColor, projectsList) {
        this.primaryColor = primaryColor
        this.secondaryColor = secondaryColor
        this.pageTitle = pageTitle
        this.projectsList = projectsList
        this.home = new Home()
        this.experience = new Experience()
        this.resources = this.experience.resources
        this.font = this.resources.items.font2
        this.backIcon = this.resources.items.backIcon
        this.scene = this.home.scene
        this.objects = []
        this.menuOptions = []
        this.interaction = this.home.interaction
        this.descriptionMaxCharactersPerLine = 30

        this.setup()
        // this.backButton()
        this.projects()
    }

    wrapText(value, maxCharactersPerLine = this.descriptionMaxCharactersPerLine) {
        if (!value) {
            return ""
        }

        const words = value.split(" ")
        const lines = []
        let currentLine = ""

        for (const word of words) {
            const nextLine = currentLine ? `${currentLine} ${word}` : word

            if (nextLine.length > maxCharactersPerLine && currentLine) {
                lines.push(currentLine)
                currentLine = word
            }
            else {
                currentLine = nextLine
            }
        }

        if (currentLine) {
            lines.push(currentLine)
        }

        return lines.join("\n")
    }

    prepareProjectTexture(texture) {
        if (!texture) {
            return texture
        }

        texture.colorSpace = THREE.SRGBColorSpace
        texture.needsUpdate = true

        return texture
    }

    projects() {


        this.backgroundPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(9, 9),
            new THREE.MeshBasicMaterial({
                color: this.secondaryColor
            })
        )
        this.foregroundPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(9, 9),
            new THREE.MeshBasicMaterial({
                color: this.primaryColor,
            })
        )
        this.imagePlane = new THREE.Mesh(
            new THREE.PlaneGeometry(8.8, 8.8),
            new THREE.MeshBasicMaterial({
                map: null,
                transparent: true,
                opacity: 0,
                toneMapped: false
            })
        )
        this.backgroundPlane.position.set(0.2, -0.2, 0)
        this.mainImage = new THREE.Group()
        this.mainImage.add(this.backgroundPlane, this.imagePlane, this.foregroundPlane)
        this.mainImage.position.set(5, 1.5, 0)
        this.scene.add(this.mainImage)
        this.setDescription()
        this.objects.push(this.mainImage, this.backgroundPlane, this.imagePlane, this.foregroundPlane)
        this.totalProjectItems = this.projectsList.length
        for (let i = 0; i < this.totalProjectItems; i++) {
            const item = this.projectsList[i]
            const isObject = !Array.isArray(item) && typeof item === "object"
            const title = isObject ? item.name : item[0]
            const image = isObject ? item.image : item[1]
            const desc = isObject ? item.listDescription : item[2]
            this.currentProject(title, image, desc, i * 1.5)
        }

        this.interaction.setPrefs(this.menuOptions, "#ffff00", "#acacac", false, 0.6, this.imagePlane, this.projectsList, this.description, this.primaryColor, this.secondaryColor, this.pageTitle)
    }

    setDescription(currentIndex = 0){
        const item = this.projectsList[currentIndex]
        const isObject = !Array.isArray(item) && typeof item === "object"
        const desc = isObject ? item.listDescription : item[2]
        this.description = this.setText(
            this.wrapText(desc),
            0.5,
            "#ffffff",
            new THREE.Vector3(0.5, -5, 0),
            false
        )
        this.description.userData.maxCharactersPerLine = this.descriptionMaxCharactersPerLine
    }

    currentProject(projectTitle, projectImage, projectText, offset) {
        this.menuOptions.push(this.setText(
            projectTitle,
            0.6,
            "#ffffff",
            new THREE.Vector3(-10, 4.5 - offset, 0),
            false
        ))
    }

    setup() {
        this.titleBackground = this.setText(
            this.pageTitle,
            1.5,
            this.secondaryColor,
            new THREE.Vector3(-9.89, 6.89, 0)
        )
        this.title = this.setText(
            this.pageTitle,
            1.5,
            this.primaryColor,
            new THREE.Vector3(-10, 7, 0)
        )
        
    }

    setText(value, fontSize, fontColor, textPosition, center = false, wrap = false) {
        const geometry = new TextGeometry(value, {
            font: this.font,
            size: fontSize,
            depth: 0,
            curveSegments: 12
        })

        if (center) {
            geometry.center()
        }

        const text = new THREE.Mesh(
            geometry,
            new THREE.MeshBasicMaterial({
                color: fontColor
            })
        )
        text.position.copy(textPosition)
        this.scene.add(text)
        this.objects.push(text)
        text.text = value
        return text
    }

    destroy() {
        this.interaction.destroy()
        for (const object of this.objects) {
            this.scene.remove(object)
            if (object.geometry) object.geometry.dispose()
            if (object.material) {
                if (Array.isArray(object.material)) {
                    for (const material of object.material) material.dispose()
                } else {
                    object.material.dispose()
                }
            }
        }
    }
}

